module.exports = __webpack_public_path__ + "img/donante-anahuac-mexico-norte.689bb2bb.jpeg";